module.exports = __webpack_public_path__ + "img/file-text-fill.35bca344.svg";